'use strict'

const _ = require('lodash')

/**
 * deep pack object to the format required for storing as a valid schema
 * restructure objects containing '$refs'
 * @param obj
 * @returns {Object} packed copy of obj
 */
const pack = prop => {
    const key = _.head(_.keys(prop))
    const value = prop[key]
    const result = {[key]: {}}
    if (value.type === 'array') {
        result[key] = {
            allOf: [
                _.assign(
                    pack({items: value.items}),
                    _.pick(value, ['title', 'description', 'default', 'type'])
                )
            ]
        }
    } else if (_.has(value, '$ref')) {
        result[key] = {
            allOf: [
                {$ref: value.$ref},
                _.pick(value, ['title', 'description', 'default', 'minLength', 'maxLength', 'maximum', 'minimum', 'multipleOf'])
            ]
        }
    } else if (_.has(value, 'properties')) {
        const properties = {}
        _.forOwn(value.properties, (propValue, propKey) => {
            _.assign(properties, pack({[propKey]: propValue}))
        })
        result[key] = _.assign(
            {properties},
            _.pick(value, ['title', 'description', 'default', 'type', '$id', 'propertiesOrder']),
        )
    } else {
        result[key] = value
    }
    return result
}

module.exports = {
    pack
}

